export const filterIndexes = <T>(items: Array<T>, fn: (item: T) => boolean) =>
  items.reduce<number[]>(
    (prev, cur, idx) => (fn(cur) ? [...prev, idx] : prev),
    [],
  );

export const allEqual = (...arr: unknown[]) =>
  arr.every((val) => val === arr[0]);

export const isNotUndefined = <T>(val: T | undefined): val is T =>
  val !== undefined;
